export default {
  methods: {
    // 第一页
    firstPage(fnRender) {
      if (!this.pdf || this.pdf?.curPage === 1) return
      this.pdf.curPage = 1
      fnRender?.(this.pdf.curPage)
    },
    // 最后一页
    lastPage(fnRender) {
      if (!this.pdf || this.pdf?.curPage === this.pdf?.totalPages) return
      this.pdf.curPage = this.totalPages
      fnRender?.(this.pdf.curPage)
    },
    // 上一页
    prevPage(fnRender) {
      if (!this.pdf || this.pdf?.curPage === 1) return
      this.pdf.curPage -= 1
      fnRender?.(this.pdf.curPage)
    },
    // 下一页
    nextPage(fnRender) {
      if (!this.pdf || this.pdf?.curPage === this.pdf?.totalPages) return
      this.pdf.curPage += 1
      fnRender?.(this.pdf.curPage)
    },
    handleView(item, fnRender, disabledModalView) {
      if (disabledModalView) return
      // if (!this.pdf?.pdfDoc) this.$Message.warning('PDF 正在加载中...')
      // console.log('PDF handleView item: ', item)
      this.firstPage(fnRender)
      this.visible = true
    },
  },
}
